import { render, staticRenderFns } from "./TravelerTypeList.vue?vue&type=template&id=9bea7822&"
import script from "./TravelerTypeList.vue?vue&type=script&lang=js&"
export * from "./TravelerTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports